export default {"src":"/_next/static/media/myketmarket.a7b34fb0.svg","height":52,"width":176};